import { vnTemplate } from '../../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate';
import { listPagePagination_template as pagination_template } from '~/components/templates/listPagePagination_template';
import { resultsInfo_template } from '../../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template';
import { renderQuestionBanksTable } from '~/components/recruiting/question-banks-table';
import { html, LpButton, LpPageHeader } from '~/design-system';
export class adminQuestionBanks_template extends vnTemplate {
    /**
     * Return the template key used by the Valnet template framework.
     *
     * @return string
     */
    getTemplateName() {
        return 'adminQuestionBanks-template';
    }
    /**
     * Return the CSS classes applied to the template root element.
     *
     * @return Array<string>
     */
    getMainElementClasses() {
        return ['question-banks-page'];
    }
    /**
     * Initialize nested template partials used by this template.
     *
     * @return void
     */
    initPartial() {
        this.pagination = new pagination_template('adminQuestionBanksPagination', this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 20;
        this.resultsInfo = new resultsInfo_template('adminQuestionBanksResultInfo', this.getTemplateViewModel(), this.caller);
    }
    /**
     * Build the Knockout view model used by this template.
     *
     * @return any
     */
    buildViewModel() {
        const self = this;
        return {
            questionBanks: ko.observableArray([]),
            orderBy: ko.observable('id'),
            orderByDirection: ko.observable('ASC'),
            orderByAndDirection: ko.observable('id_ASC'),
            onClickReorder: function (value, data, event) { self.onClickReorder(value, data, event); },
            onClickEdit: function (row) { self.caller.editQuestionBank(row.id); },
            onClickCreate: function () { self.caller.createQuestionBank(); },
            onClickAvailableQuestions: function () { self.caller.openAvailableQuestions(); },
        };
    }
    /**
     * Return the HTML markup for this template.
     *
     * @return string
     */
    getTemplateHtml() {
        return `
            <div class="w-content question-banks-page__content">
            ${LpPageHeader({
            title: 'Question Banks',
            description: 'Manage question bank definitions and assigned questions.',
            icon: 'cards',
            actions: html `
                    ${LpButton({
                label: 'Questions',
                prefixIcon: 'question',
                size: 'base',
                variant: 'secondary',
                attributes: {
                    'data-bind': 'click: onClickAvailableQuestions',
                },
            })}
                    ${LpButton({
                label: 'Create',
                prefixIcon: 'plus',
                size: 'base',
                variant: 'primary',
                attributes: {
                    'data-bind': 'click: onClickCreate',
                },
            })}
                `,
        })}

            <div class="list-page-module question-banks-module">
                <div class="data-module__body list-page-module__body" id="list-results">
                    ${renderQuestionBanksTable({ getSortAttributes: (column) => this.getSortAttributes(column) })}
                </div>
                <div class="data-module__footer list-page-module__footer">
                    <div class="list-page-module__toolbar">
                        <div class="list-page-module__meta">
                            ${this.resultsInfo.getHtmlBuild()}
                        </div>
                        <div class="list-page-module__pagination">
                            ${this.pagination.getHtmlBuild()}
                        </div>
                    </div>
                </div>
            </div>
            </div>
        `;
    }
    getSortAttributes(column) {
        return {
            'data-bind': `click: onClickReorder.bind($data, '${column}'), css: { 'is-desc': orderByAndDirection()=='${column}_DESC', 'is-asc': orderByAndDirection()=='${column}_ASC' }`,
        };
    }
    /**
     * Build the request payload from the current view model state.
     *
     * @return object
     */
    getViewModelForRequest() {
        const vm = this.getTemplateViewModel();
        return {
            sortBy: vm.orderBy(),
            sortDirection: vm.orderByDirection(),
            pagination: this.getPaginationViewModel(),
        };
    }
    /**
     * Return the pagination partial view model.
     *
     * @return any
     */
    getPaginationViewModel() {
        return this.pagination ? this.pagination.getTemplateViewModel() : null;
    }
    /**
     * Apply question bank rows returned by the API to the view model.
     *
     * @param questionBanks Array<any>
     * @return void
     */
    setQuestionBanks(questionBanks) {
        this.getTemplateViewModel().questionBanks(questionBanks || []);
    }
    /**
     * Update the pagination partial with the result count.
     *
     * @param totalCount any
     * @return void
     */
    updatePagination(totalCount) {
        if (this.pagination) {
            this.pagination.setNumberItemToPaginate(totalCount);
        }
    }
    /**
     * Update the result-info partial with list metadata.
     *
     * @param totalResults number
     * @param totalPages number
     * @param execTime number
     * @return void
     */
    setResultInfo(totalResults, totalPages, execTime) {
        this.resultsInfo.setNbResults(totalResults);
        this.resultsInfo.setNbPages(totalPages);
        this.resultsInfo.setExecutionTime(execTime);
    }
    /**
     * Reset the list pagination to the first page.
     *
     * @return void
     */
    resetPageNumber() {
        const paginationVm = this.getPaginationViewModel();
        if (paginationVm && typeof paginationVm.pageNumber === 'function') {
            paginationVm.pageNumber(1);
        }
    }
    /**
     * Set view model from request on the view model.
     *
     * @param params Array<any>
     * @return void
     */
    setViewModelFromRequest(params) {
        const vm = this.getTemplateViewModel();
        if (typeof params['pagination'] !== 'undefined' && params['pagination'] && vm.pagination && typeof vm.pagination.pageNumber === 'function') {
            vm.pagination.pageNumber(Math.max(1, Number(params['pagination'].pageNumber || 1)));
        }
        if (typeof params['sortBy'] !== 'undefined') {
            vm.orderBy(params['sortBy']);
        }
        if (typeof params['sortDirection'] !== 'undefined') {
            const direction = String(params['sortDirection']).toUpperCase() === 'DESC' ? 'DESC' : 'ASC';
            vm.orderByDirection(direction);
            vm.orderByAndDirection(vm.orderBy() + '_' + direction);
        }
    }
    /**
     * Handle on click reorder.
     *
     * @param value any
     * @param data any
     * @param event any
     * @return void
     */
    onClickReorder(value, data, event) {
        if (typeof data.orderBy === 'undefined') {
            data = this.getTemplateViewModel();
        }
        data.orderBy(value);
        if (data.orderByAndDirection() && data.orderByAndDirection().includes(value)) {
            data.orderByDirection(data.orderByDirection() === 'DESC' ? 'ASC' : 'DESC');
        }
        else {
            data.orderByDirection('DESC');
        }
        data.orderByAndDirection(value + '_' + data.orderByDirection());
        this.caller.listReorder();
    }
}
